import axios from '../axios';

export default () => ({
  list: () => axios.get('/api/result/list'),
  release: () => axios.get('/api/result/release'),
  create: (jackpot: string) => axios.post('/api/result/create', { data: { jackpot } }),
});
